require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-and-dev-bootcamp-partner-to-support-students.json") })
        }
      }, "path---blog-code-fellows-and-dev-bootcamp-partner-to-support-students");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-and-dev-bootcamp-partner-to-support-students!./.cache/json/blog-code-fellows-and-dev-bootcamp-partner-to-support-students.json
// module id = 767
// module chunks = 231608221292675